<div class="div_venue" >
  <div class="pos-title-header">
    <label class="lbl_top">{{'MENU.MY_MENUS' | translate}}</label>
  </div>
  <div class="cards_div_wrapper">
    <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
    <div *ngFor="let menu of listAllMenus" class="menu_div h-auto">
      <div class="div_content m-0" (click)="navigateToDetails(menu.id)">
        <label class="w-100 menu-name" title="{{menu.name}}">{{menu.name}}</label>
        <span class="menu-created">{{'MENU.CREATED' | translate}}: {{menu.createDate | date: 'dd-MM-YYYY'}}</span>
      </div>
    </div>
  </div>
</div>
